import { RollingTextList, ListItem } from "@/components/ui/rolling-list";
import { PHOTOS, getMobileUrl } from "@/lib/photos";

const items: ListItem[] = [
  {
    id: 1,
    title: "Tickets",
    category: "Get Yours",
    src: getMobileUrl(PHOTOS.STAGE.bandDramaticLights),
    src2: getMobileUrl(PHOTOS.CROWD.audienceHandsRaised),
    alt: "YRD Event",
    href: "/tickets",
  },
  {
    id: 2,
    title: "Guide",
    category: "Know Before",
    src: getMobileUrl(PHOTOS.DJ.behindWithCrowd),
    src2: getMobileUrl(PHOTOS.BAR.threePeopleCaptainOutfits),
    alt: "YRD Event",
    href: "/guide",
  },
  {
    id: 3,
    title: "Lineup",
    category: "Who's Playing",
    src: getMobileUrl(PHOTOS.STAGE.fullBandCaptainHats),
    src2: getMobileUrl(PHOTOS.STAGE.nighttimePurpleLights),
    alt: "YRD Event",
    href: "/lineup",
  },
  {
    id: 4,
    title: "Travel",
    category: "Getting There",
    src: getMobileUrl(PHOTOS.VENUE.roostertailExteriorNight),
    src2: getMobileUrl(PHOTOS.BOAT.groupSixPeopleWaving),
    alt: "YRD Event",
    href: "/travel",
  },
];

const BigWordsSection = () => {
  return (
    <section className="py-16 md:py-24 px-6 bg-yacht-blue relative z-10 overflow-hidden">
      {/* Noise texture overlay */}
      <div 
        className="absolute inset-0 opacity-[0.12] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />
      <div className="relative z-10 max-w-6xl mx-auto">
        <RollingTextList items={items} />
      </div>
    </section>
  );
};

export default BigWordsSection;
